import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import './NaszeRealizacje.css'

const projects = [
  {
    id: 1,
    title: 'Montaż drzwi',
    desc: 'Drzwi wypadły i wymagały ponownego montażu – drzwi wewnętrzne. Poniżej znajdują się dwa zdjęcia: przed naprawą i po niej, pokazujące problem oraz zastosowane rozwiązanie. Montaż został wykonany dokładnie, aby drzwi działały poprawnie i bezpiecznie.',
    time: '4 godziny',
    imageBefore: '/images/project1-after.jpg',
    imageAfter: '/images/project1-before.jpg'
  },
  {
    id: 2,
    title: 'Montaż szafy',
    desc: 'Profesjonalny montaż szafy z IKEA. Szafa zamontowana stabilnie i zgodnie z instrukcją producenta, gotowa do użytkowania.',
    time: '2 godziny',
    image: '/images/project2-wardrobe.jpg'
  },
  {
    id: 3,
    title: 'Montaż listew przypodłogowych',
    desc: 'Profesjonalny montaż listew przypodłogowych – estetycznie i stabilnie dopasowane do wnętrza. Praca wykonana starannie, z dbałością o szczegóły, gwarantując trwały i elegancki efekt.',
    time: '12 godzin',
    images: ['/images/project3-baseboard-1.jpg', '/images/project3-baseboard-2.jpg', '/images/project3-baseboard-3.jpg']
  },
  {
    id: 4,
    title: 'Montaż siatki na balkon',
    desc: 'Profesjonalny montaż siatki na balkon, skutecznie chroniącej przed gołębiami. Siatka zamontowana starannie i bezpiecznie, estetycznie dopasowana do balkonu, zapewniając spokój i czystość w przestrzeni.',
    time: '3 godziny',
    image: '/images/project4-balcony.jpg'  },
  {
    id: 5,
    title: 'Montaż zlewu kuchennego',
    desc: 'Nowy zlew kuchenny zamontowany precyzyjnie i solidnie, z dbałością o szczelność i wygodę użytkowania. Gotowy do codziennej pracy, zapewnia komfort podczas gotowania i mycia naczyń.',
    time: '2 godziny',
    image: '/images/project5-sink.jpg'
  },
  {
    id: 6,
    title: 'Montaż umywalki łazienkowej',
    desc: 'Umywalka łazienkowa zamontowana precyzyjnie, z uwzględnieniem trudności przy dopasowywaniu. Praca wykonana starannie, z dbałością o szczelność i estetykę, zapewniając wygodę i trwałość użytkowania.',
    time: '6 godzin',
    images: ['/images/project6-bathroom-1.jpg', '/images/project6-bathroom-2.jpg', '/images/project6-bathroom-3.jpg', '/images/project6-bathroom-4.jpg']
  },
  {
    id: 7,
    title: 'Montaż listwy przypodłogowej',
    desc: 'Zamontowałem listwę przypodłogową na krótkim odcinku 1,5 m. Niewielkie prace też nie stanowią dla nas problemu – wszystko wykonane dokładnie i estetycznie, aby efekt był trwały i ładnie wyglądał w pomieszczeniu.',
    time: '1,5 godziny',
    image: '/images/project7-baseboard-small.jpg'
  },
  {
    id: 8,
    title: 'Malowanie placu zabaw ogrodowego',
    desc: 'Drewniany plac zabaw został odświeżony poprzez staranne malowanie. Powierzchnia została odpowiednio przygotowana, a następnie pokryta farbą, co poprawiło estetykę oraz zabezpieczyło drewno przed warunkami atmosferycznymi.',
    time: '3 dnie',
    imageBefore: '/images/home.jpg',
    imageAfter: '/images/home2.jpg'
  },
  {
    id: 9,
    title: 'Montaż płyt warstwowych na dachu',
    desc: 'Profesjonalny montaż płyt warstwowych na dachu – precyzyjnie dopasowane i zabezpieczone. Praca wymagająca dokładności i doświadczenia, wykonana z pełnym zaangażowaniem w każdym detalu, zapewniając trwałość, szczelność i estetykę dachu.',
    time: 'Zależy od zlecenia',
    images: ['/images/project9-detail-1.jpg', '/images/project9-detail-2.jpg']
  },
  {
    id: 10,
    title: 'Malowanie ścian i sufitów',
    desc: 'Ściany i sufity w dwóch pomieszczeniach zostały odświeżone poprzez staranne malowanie. Przed rozpoczęciem prac zabezpieczono wyposażenie i przygotowano powierzchnie, a następnie nałożono farbę, uzyskując jasne, równomierne wykończenie.',
    time: 'Zależy od zlecenia',
    imageBefore: '/images/project10-before.jpg',
    imageAfter: '/images/project10-after.jpg',
    additionalBeforeAfter: [{
      imageBefore: '/images/project10-extra-before.jpg',
      imageAfter: '/images/project10-extra-after.jpg'
    }]
  },
  {
    id: 11,
    title: 'Montaż drzwi wejściowych',
    desc: 'Montaż drzwi wejściowych. Prace obejmowały osadzenie drzwi w otworze oraz zabezpieczenie skrzydeł przed zabrudzeniem i uszkodzeniem podczas dalszych prac.',
    time: 'Zależy od zlecenia',
    images: [
      '/images/project11-door-1.jpg',
      '/images/project11-door-2.jpg',
      '/images/project11-door-3.jpg',
      '/images/project11-door-4.jpg'
    ]
  }
]

function NaszeRealizacje() {
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [lightboxImage, setLightboxImage] = useState(null)

  useEffect(() => {
    document.body.classList.add('night-home')

    return () => {
      document.body.classList.remove('night-home')
      document.body.style.overflow = ''
    }
  }, [])
  const openLightbox = (src) => {
    setLightboxImage(src)
    setLightboxOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const closeLightbox = () => {
    setLightboxOpen(false)
    setLightboxImage(null)
    document.body.style.overflow = ''
  }

  return (
    <div className="realizacje">
      {/* ─── HERO ─── */}
      <section className="realizacje__hero">
        <Link to="/" className="realizacje__back">
          <ArrowLeft size={24} />
        </Link>
        <h1>Zrealizowane zlecenia</h1>
        <p>Precyzja, jakość i pełne zaangażowanie w każdym detalu.</p>
      </section>

      {/* ─── PROJECTS GRID ─── */}
      <section className="realizacje__container">
        <div className="realizacje__grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              {(project.imageBefore || project.imageAfter) && (
                <div className="project-card__images">
                  {project.imageBefore && (
                    <div className="project-card__image">
                      <img src={project.imageBefore} alt={`${project.title} - przed`} onClick={() => openLightbox(project.imageBefore)} style={{cursor: 'pointer'}} onError={e => { e.target.style.display = 'none' }} />
                      <span className="project-card__label">Przed</span>
                    </div>
                  )}
                  {project.imageAfter && (
                    <div className="project-card__image">
                      <img src={project.imageAfter} alt={`${project.title} - po`} onClick={() => openLightbox(project.imageAfter)} style={{cursor: 'pointer'}} onError={e => { e.target.style.display = 'none' }} />
                      <span className="project-card__label">Po</span>
                    </div>
                  )}
                </div>
              )}
              {project.additionalBeforeAfter?.map((pair, idx) => (
                <div key={idx} className="project-card__images">
                  <div className="project-card__image">
                    <img src={pair.imageBefore} alt={`${project.title} - przed`} onClick={() => openLightbox(pair.imageBefore)} style={{cursor: 'pointer'}} onError={e => { e.target.style.display = 'none' }} />
                    <span className="project-card__label">Przed</span>
                  </div>
                  <div className="project-card__image">
                    <img src={pair.imageAfter} alt={`${project.title} - po`} onClick={() => openLightbox(pair.imageAfter)} style={{cursor: 'pointer'}} onError={e => { e.target.style.display = 'none' }} />
                    <span className="project-card__label">Po</span>
                  </div>
                </div>
              ))}
              {project.images && (
                 <div className={`project-card__gallery ${project.images.length === 4 ? 'project-card__gallery--four' : ''}`}>
                  {project.images.map((img, idx) => (
                    <div key={idx} className="project-card__image">
                      <img src={img} alt={`${project.title} - ${idx + 1}`} onClick={() => openLightbox(img)} style={{cursor: 'pointer'}} onError={e => { e.target.style.display = 'none' }} />
                    </div>
                  ))}
                </div>
              )}
              {project.image && (
                <div className="project-card__image">
                  <img src={project.image} alt={project.title} onClick={() => openLightbox(project.image)} style={{cursor: 'pointer'}} onError={e => { e.target.style.display = 'none' }} />
                </div>
              )}
              
              <div className="project-card__content">
                <h3>{project.title}</h3>
                <p className="project-card__desc">{project.desc}</p>
                <div className="project-meta">
                  <span className="project-meta__time">⏱ Czas: {project.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ─── LIGHTBOX MODAL ─── */}
      {lightboxOpen && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox__content" onClick={(e) => e.stopPropagation()}>
            <img src={lightboxImage} alt="Enlarged view" className="lightbox__image" />
            <button className="lightbox__close" onClick={closeLightbox}>✕</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default NaszeRealizacje
